var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../../../action/au.action';
import { MessageService } from '../../../../service/message.service';
import { PageService } from '../../../../models/page.service';
import { ContentBaseComponent } from '../../../../component/base/contentbase.component';
import { KtsOutlineService, TaskOutline, TaskTemplate } from './outline.service';
import { AlertModalService } from '../../../../component/alertmodal/alertmodal.service';
import { ValidationService } from '../../../../service/validation.service';
var KtsOutlineComponent = /** @class */ (function (_super) {
    __extends(KtsOutlineComponent, _super);
    function KtsOutlineComponent(router, route, logger, action, message, page, service, alertModalService, validService) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.alertModalService = alertModalService;
        _this.validService = validService;
        _this.items = [];
        _this.deleteItems = [];
        _this.seq = 1;
        _this.readonly = false;
        _this.deleteFlg = false;
        return _this;
    }
    KtsOutlineComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        this.setCompRec();
    };
    KtsOutlineComponent.prototype.onMsg = function (msg) {
        this.taskTemplate = new TaskTemplate(msg, this.readonly);
    };
    KtsOutlineComponent.prototype.setUnsubscribe = function () {
        this.changeSubscription.unsubscribe();
    };
    KtsOutlineComponent.prototype.onSubscribe = function (data) {
        if (typeof data.project_m_id !== 'undefined') {
            this.projectMId = data.project_m_id;
            return;
        }
        this.items = [];
        this.deleteItems = [];
        this.deleteFlg = false;
        this.service.resetFieldComp();
        var items = [];
        if (typeof data.items !== 'undefined' && data.items instanceof Array) {
            items = data.items;
        }
        this.seq = 1;
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (typeof item.id !== 'undefined') {
                item.$type = "put" /* Put */;
            }
            item.$seq = this.seq++;
            this.items.push(item);
        }
        this.setCompRec();
    };
    KtsOutlineComponent.prototype.onModeSubscribe = function (mode) {
        this.readonly = false;
        if (mode === 'confirm') {
            this.readonly = true;
        }
    };
    KtsOutlineComponent.prototype.onEventSubscribe = function (e) {
        if (e === this.componentName + '#button') {
            // 必須チェック
            var event_1 = this.action.getEvent('outlineSave');
            if (typeof event_1.action === 'undefined') {
                return;
            }
            var valid = this.validService.validation('submit', event_1, this.action.getCompRec(), this.msgSnapshot);
            if (!valid.validation) {
                return;
            }
            // 確認のアラートモーダルを表示
            var msg = this.deleteFlg ? this.msgSnapshot['au.COMPONENT.KtsOutlineComponent.Modal.save.confirmIncludingDelete'] : this.msgSnapshot['au.COMPONENT.KtsOutlineComponent.Modal.save.confirm'];
            this.alertModalService.open({
                message: msg,
                buttons: [{
                        class: 'ok',
                        event: this.componentName + '#save#ok',
                        caption: this.msgSnapshot['Modal.button.ok']
                    }, {
                        class: 'cancel',
                        event: this.componentName + '#save#cancel',
                        caption: this.msgSnapshot['Modal.button.cancel']
                    }]
            });
        }
        else if (e === this.componentName + '#save#ok') {
            // 工事概要保存
            this.action.firstAction('outlineSave');
        }
    };
    KtsOutlineComponent.prototype.onEvent = function (e1, e2, index) {
        if (e2 === 'add') {
            this.items.splice(index + 1, 0, Object.assign(new TaskOutline(), { $seq: this.seq++ }));
        }
        else if (e2 === 'delete') {
            if (typeof this.items[index].id !== 'undefined' && this.items[index].id !== null) {
                this.items[index].$type = "delete" /* Delete */;
                this.deleteItems.push(this.items[index]);
                this.deleteFlg = true;
            }
            this.items.splice(index, 1);
        }
        else if (e2 === 'up') {
            this.items.splice(index - 1, 2, this.items[index], this.items[index - 1]);
        }
        else if (e2 === 'down') {
            this.items.splice(index, 2, this.items[index + 1], this.items[index]);
        }
        this.setCompRec();
    };
    KtsOutlineComponent.prototype.onChange = function (e, index) {
        this.items[index][e.key] = e.val;
        if (typeof e.delFlg !== 'undefined' && e.delFlg === true) {
            this.deleteFlg = true;
        }
        this.setCompRec();
    };
    KtsOutlineComponent.prototype.setCompRec = function () {
        var data = [];
        var items = JSOG.parse(JSON.stringify(this.items));
        var deleteItems = JSOG.parse(JSON.stringify(this.deleteItems));
        var order = 1;
        for (var _i = 0, items_2 = items; _i < items_2.length; _i++) {
            var item = items_2[_i];
            delete item.$seq;
            item.project_m_id = this.projectMId;
            item.disp_order = order++;
            data.push(item);
        }
        for (var _a = 0, deleteItems_1 = deleteItems; _a < deleteItems_1.length; _a++) {
            var item = deleteItems_1[_a];
            delete item.$seq;
            data.push(item);
        }
        this.action.setCompRec(this.componentName, { items: data });
    };
    KtsOutlineComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'kts-outline',
                    template: "<form id=\"{{ componentName }}\">\n  <div class=\"row -m-2\">\n    <div class=\"col-sm-12\">\n      <ul class=\"form form-campaign\">\n        <li *ngFor=\"let item of items; let index = index;\" class=\"stageFlowPane\">\n          <div *ngIf=\"!readonly\" class=\"stageFlow_arrowsWrapper\">\n            <ul class=\"stageFlow_arrows\">\n              <li *ngIf=\"index > 0\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_up\" (click)=\"onEvent($event, 'up', index)\"></a></li>\n              <li *ngIf=\"index < items.length - 1\"><a href=\"javascript:void(0);\" class=\"stageFlow_arrows_down\" (click)=\"onEvent($event, 'down', index)\"></a></li>\n            </ul>\n          </div>\n          <div class=\"stageFlowPane_border\">\n            <p *ngIf=\"!readonly\"><a class=\"deleteBtn\" href=\"javascript:void(0);\" (click)=\"onEvent($event, 'delete', index)\"></a></p>\n            <div class=\"row -mt-2 -mx-1\">\n              <div class=\"col-sm-12\">\n                <column [key]=\"'form'\" [componentName]=\"componentName\" [index]=\"item.$seq\" [col]=\"taskTemplate.name\" [val]=\"item\" [msg]=\"(msg | async)\" (setChangeVal)=\"onChange($event, index)\"></column>\n              </div>\n            </div>\n            <div class=\"row -mt-2 -mx-1 -mb-1\">\n              <div class=\"col-sm-12\">\n                <kts-outline-field\n                    [componentName]=\"componentName + '#field' + item.$seq\"\n                    [component]=\"{name: componentName + '#field' + item.$seq, params: {primaryKey: 'id', maxRows: '10'}}\"\n                    [fieldCols]=\"taskTemplate.field\"\n                    [vals]=\"item\"\n                    (changeField)=\"onChange($event, index)\"></kts-outline-field>\n              </div>\n            </div>\n          </div>\n          <button *ngIf=\"index < items.length - 1 && !readonly\" class=\"addBtn -mt-2\" type=\"button\" (click)=\"onEvent($event, 'add', index)\"></button>\n        </li>\n      </ul>\n      <button *ngIf=\"!readonly\" class=\"addBtn -mt-0\" [class.-mt-2]=\"items.length > 0\" type=\"button\" (click)=\"onEvent($event, 'add', items.length - 1)\"></button>\n    </div>\n  </div>\n  <div class=\"row -mt-1\">\n    <div class=\"col-sm-12\">\n      <btn [componentName]=\"componentName + '#button'\"\n           [component]=\"{\n             params: {\n               buttons: [{\n                 type: 'button',\n                 event: componentName + '#button',\n                 caption: (msg | async)['Button_save']\n               }]\n             }\n           }\"></btn>\n    </div>\n  </div>\n</form>\n"
                }] }
    ];
    /** @nocollapse */
    KtsOutlineComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: KtsOutlineService },
        { type: AlertModalService },
        { type: ValidationService }
    ]; };
    return KtsOutlineComponent;
}(ContentBaseComponent));
export { KtsOutlineComponent };
//# sourceMappingURL=outline.component.js.map